$(document).ready(function(){ 
var location_url = window.location.href;
if(location_url.indexOf('?stock=') >-1){
 var gemstone_id = location_url.split('?stock=')[1];
}else{
window.location.href='https://my-solitaire.myshopify.com/pages/gemstones'
}
 fetch(window.API_URL+`diamonds/singleGemstone/${gemstone_id}`, {
        method: 'GET',
       
        headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
    }).then(res => res.json())
        .then(response => {
            console.log(response)
            gemstion_data(response)
        });
         function gemstion_data(response){
            console.log(response);
            if(response.VideoUrl.indexOf('mp4') > -1){
              gemstone_360(response);
            }
            if(response.Image1 != null && response.Image1 !='-' || response.Image2 != null && response.Image2 != '-' && response.Image2 != '' && response.Image2 != '\r' || response.Image3 != null && response.Image3 != '-' && response.Image3 != '' && response.Image3 != '\r'){
            gemstone_images(response);
            }
            $('#first-title').text(response.Title);
            tabs(response)
            var price =  parseFloat(response.Price2);
            if(response.Price2 != '' && response.Price2 != null ){
             price = toCurrencyFormat(price);
            }else{
             price = toCurrencyFormat(0);;
              }
            $('#price').text(price);
            $('#more-detail span#detail-number').text(response.Stock);
            if(response.Location != ''){
              $('span#detail-origin').text(response.Location);
            }else{
            $('span#detail-origin').text('None');
            }
            $('span#detail-price').text(price);
            if(response.Measurements != ''){
               $('span#detail-measurements').text(response.Measurements);
            }else{
               $('span#detail-measurements').text('None');
            }
            $('span#detail-shape').text(response.Shape);
            if(response.ColorHue != ''){
            $('span#detail-color').text(response.ColorHue);
            }else{
            $('span#detail-color').text('None');
            }
            if(response.Treatment != '' && response.Treatment != null){
            $('span#detail-Treatment').text(response.Treatment);
            }else{
            $('span#detail-Treatment').text('None');
            }
            if(response.Gemstone != ''){
            $('span#detail-Gemstone').text(response.Gemstone);
            }else{
            $('span#detail-Gemstone').text('None');
            }
            if(response.Quality != ''){
              let Quality = '';
              if(response.Quality == 'A'){
                Quality = 'Good'
              }else if(response.Quality == 'AA'){
                Quality = 'Fine'
              }
              else if(response.Quality == 'AAA'){
                Quality = 'PREMIUM'
              }
              else if(response.Quality == 'AAAA'){
                Quality = 'EXCEPTIONAL'
              }
              if(Quality != ''){
                 $('span#detail-Quality').text(Quality);
              }
              else{
            $('span#detail-Quality').text('None');
            }
            }
} 
  function gemstone_images(response) {

     if(response.Image1 != null && response.Image1 !='-'){
          
            $('#grid-img-diamond #diamond-image1 img#diamond-img1,#diamond-image-mob-1 img').attr('src',response.Image1);
            }
           if(response.Image2 != null && response.Image2 != '-' && response.Image2 != '' && response.Image2 != '\r'){
             
              $('#grid-img-diamond #diamond-image2,#diamond-image-mob-2').html(`<img src="${response.Image2}" alt="" class='inner' id="diamond-img2">`);
            }
           if(response.Image3 != null && response.Image3 != '-' && response.Image3 != '' && response.Image3 != '\r'){
             
               $('#grid-img-diamond #diamond-image3,#diamond-image-mob-3').html(`<img src="${response.Image3}" alt="" class='inner' id="diamond-img3">`);
            }
             if(response.Image4 != null && response.Image4 != '-'&& response.Image4 != '' && response.Image4 != '\r'){
               
               $('#grid-img-diamond #diamond-image4,#diamond-image-mob-4').html(`<img src="${response.Image4}" alt="" class='inner' id="diamond-img4">`);
            }
             if(response.CertImageFile != null && response.CertImageFile != '' && response.CertImageFile != '\r'){
               
               $('#grid-img-diamond #diamond-image6,#diamond-image-mob-6').html(`<img src="${response.CertImageFile}" alt="" class='inner' id="diamond-img6">`);
            }
     if($('.carousel-item1 .inner').length >1){
        $('.carousel-item1:empty').remove();
       $('.carousel-inner').slick();
     }
  }
  function gemstone_360(response){
        let proster_img = `<img src="${response.Image1}" alt="gemstone_poster" id="_360_poster_image" class="poster_image">`
        let _360icon = `<span class="_360_icons gemstone"><img src="https://cdn.shopify.com/s/files/1/0576/3350/5416/files/360-view.svg?v=1712654633" class="_360_rotation" width=24></span>`
        let _360_container = `<div class="preview col" style="display:none">
        <div class="app-figure" id="zoom-fig">
        <a id="spin-1" class="Magic360"  data-options="autospin: infinite; autospin-stop: hover; spin: hover; rows: 1;columns: 72;magnify: false;"
         href="https://dsv7iunirnrax.cloudfront.net/360_gemstones/${response.Stock}/frame01.png"
         ><img src="https://dsv7iunirnrax.cloudfront.net/360_gemstones/${response.Stock}/frame01.png"></a>
       </div>
     </div>` 
     $('#grid-img-diamond #diamond-image5,#diamond-image-mob-5').html(`<div class="_360_main_container inner">${proster_img}${_360_container}${_360icon}</div>`);
  }
  $(document).on('click','#diamond-img6 img,#diamond-img6',function(e){
     e.preventDefault();
    var imgURL= $(this).attr('src');
      $('.image_popup_content img').attr('src',imgURL);
       $('.image_popup_content').css('display','grid');
    });
   $(document).on('click touchstart','#close',function(e){
     e.preventDefault();
      $(this).parents('.image_popup_content').hide();
    });
$(document).on('click','#diamond-with-setting',function () {

   let processing = false;
    let spinner = ` <svg class="tw-w-10 tw-h-10" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
        <g fill="none" fill-rule="evenodd">
            <g transform="translate(1 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"/>
                </path>
            </g>
        </g>
    </svg>`;

         $('#stock-modal').remove();
         btnText = $(this).html();
         $(this).html(spinner+' Please wait...');
         const queryString = window.location.search;
          let urlParams = new URLSearchParams(queryString);
          let diamond_id = urlParams.get('stock');
         let url = window.API_URL +`diamonds/singleGemstone/${diamond_id}`;
         console.log(url);
         fetch(url, {
            method: 'GET',        
            headers: { 'Content-type': 'application/json', 'Accept': `application/json`,'X-API-Key': 'TSANITY121A3VG7NEMVRXXEWGM' }
         }).then(res => res.json())
          .then(async diamond => {
            processing = false;
            console.log(diamond);
             set_gemstone_value(diamond);
             if(diamond && diamond.Stock) {
              let wizardStart = JSON.parse(localStorage.getItem('wizardStart'));
              let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
               var shape = diamond.Shape.toLowerCase();
              if(wizardInfo.setting_product_id == null || wizardInfo.setting_product_id == '' ){
                url = `/collections/engagement-ring-settings-with-gemstone/dyo_shape_${shape}`;
              }
              else{
                var diamond_step = localStorage.getItem("diamond_page_step");
                url = window.location.origin+"/pages/complete-gemstonering"+wizardInfo.setting_product_handle;
                }
               window.location.href = url;
              } else {
              $(btn).html(btnText);
              $('body').append("<div id='stock-modal'><div onclick='$(this).parent().remove();' class='stock-modal-close'>X</div>We're so sorry the diamond you selected is no longer available, please choose another before placing your order.</div>");
            }
          })
          .catch(error => console.error('Error:', error));
 })
$(document).on('click','#grid-img-diamond span._360_icons.gemstone',function(){
  if($(this).parents('#grid-img-diamond').find('canvas').length >0){
    $(this).parents('#grid-img-diamond').find('.poster_image').show();
    $(this).parents('._360_main_container').find('.preview').hide();
    var spiner =  $(this).parents('').find('._360_main_container .Magic360').attr('id');
    Magic360.stop(`${spiner}`); 
  }else{
 $(this).parents('#grid-img-diamond').find('.poster_image').hide();
    $(this).parents('._360_main_container').find('.preview').show();
    var spiner =  $(this).parents('').find('._360_main_container .Magic360').attr('id');
    Magic360.start(`${spiner}`); 
    }
 })
  function set_gemstone_value(stone) {
     let wizardInfo = JSON.parse(localStorage.getItem('wizardInfo_gemstone'));
     if(wizardInfo != null){
        wizardInfo.gemstone_id = stone.Stock;
        wizardInfo.gemstone_image_url = stone.Image1;
        wizardInfo['gemstone_price'] = stone.Price2;
        wizardInfo['gemstone_title'] = stone.Title;
        wizardInfo['gemstone_shape'] = stone.Shape;
        localStorage.setItem("wizardInfo_gemstone", JSON.stringify(wizardInfo));
     }else{
        localStorage.setItem("wizardInfo_gemstone", JSON.stringify(window.wizard_gemstone));
     }
  }

  
    
  
  $('.jtpl-product-tab button').click(function(){
    var tab_id =  $(this).attr('data-attr');
    $(this).addClass('active');
    $('.jtpl-product-tab button').not($(this)).removeClass('active');
    $('.jtpl-product-tab-wrapper .tabcontent').removeClass('active');
    $('.jtpl-product-tab-wrapper .tabcontent').hide();
    $('.jtpl-product-tab-wrapper #'+tab_id).addClass('active');
    $('.jtpl-product-tab-wrapper #'+tab_id).show();
   })
 function tabs(response){
   console.log(response.Description);
              $('.tablinks[data-attr="care"]').hide(); 
              if(response.Description != null && response.Description != '-'){
                $('.tablinks[data-attr="overview"]').text(`Overview (${response.Gemstone})`);
                $('.tabcontent#overview').html(`<span class="jtpl-pdp-tab-sku">
               <span class="gemstone_detail">${response.Description}</span>
              </span></br>`);
              }
             if(response.Stock != null || response.Title != null || response.Shape != null || response.Measurements != null ){
               
                $('.tabcontent#details').html('');
               $('.tabcontent#details').append(`<h2 class="h4">GEMSTONE DETAILS</h2>`);
               if(response.Stock != null){
                $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
                Sku: <span class="gemstone_detail">${response.Stock}</span>
               </span></br>`);
               }
              if(response.Gemstone != null || response.Gemstone != ''){
              $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
              Gemstone: <span class="gemstone_detail">${response.Gemstone}</span>
              </span></br>`);
               }
              if(response.Shape != null || response.Shape != ''){
              $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
              Shape: <span class="gemstone_detail">${response.Shape}</span>
              </span></br>`);
               }
               if(response.Dimension != null || response.Dimension != ''){
              $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
              Dimension: <span class="gemstone_detail">${response.Measurements}</span>
              </span></br>`);
               }
               if(response.Color != null || response.Color != ''){
              $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
              Color: <span class="gemstone_detail">${response.ColorHue}</span>
              </span></br>`);
               }
               if(response.Quality != null || response.Quality != ''){
              var Quality =''
              if(response.Quality == 'A'){
                Quality ='Good'
              }
              if(response.Quality == 'AA'){
                Quality ='FINE'
              }
              if(response.Quality == 'AAA'){
                Quality ='PREMIUM'
              }
              if(response.Quality == 'AAAA'){
                Quality ='EXCEPTIONAL'
              }
              $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
              Quality: <span class="gemstone_detail">${Quality}</span>
              </span></br>`);
               }
               if(response.Location != null && response.Location != ''){
              $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
              Origin: <span class="gemstone_detail">${response.Location}</span>
              </span></br>`);
               }
               if(response.Treatment != null && response.Treatment != '' && response.Treatment != undefined){
              $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
              Treatment: <span class="gemstone_detail">${response.Treatment}</span>
              </span></br>`);
               }
               if(response.Lab != null || response.Lab != ''){
                 var Certificate = '';
               if(response.Lab == "GIA"){
                 Certificate = "GIA"
               }
                 if(Certificate != ''){
              $('.tabcontent#details').append(`<span class="jtpl-pdp-tab-sku">
              Certificate: <span class="gemstone_detail">${Certificate}</span>
              </span></br>`);
                 }
               }
               switch (response.Gemstone) {
                case 'Aquamarine':
                  var info = $('#info-section').attr('data-gudie-aquamarine');
                  $('#care.tabcontent').html(`<span class="jtpl-pdp-tab-sku"><span class="gemstone_detail">${info}</span></span>`);
                  $('.tablinks[data-attr="care"]').show();
                  break;
                case 'Morganite':
                    var info = $('#info-section').attr('data-gudie-morganite');
                  $('#care.tabcontent').html(`<span class="jtpl-pdp-tab-sku"><span class="gemstone_detail">${info}</span></span>`);
                  $('.tablinks[data-attr="care"]').show();
                  break;
                case 'Sapphire':
                   var info = $('#info-section').attr('data-gudie-sapphire');
                   $('#care.tabcontent').html(`<span class="jtpl-pdp-tab-sku"><span class="gemstone_detail">${info}</span></span>`);
                  $('.tablinks[data-attr="care"]').show();
                  break;
                case 'Emerald':
                  var info = $('#info-section').attr('data-gudie-emerald');
                 $('#care.tabcontent').html(`<span class="jtpl-pdp-tab-sku"><span class="gemstone_detail">${info}</span></span>`);
                  $('.tablinks[data-attr="care"]').show();
                  break;
                case 'Alexandrite':
                   var info = $('#info-section').attr('data-gudie-alexandrite');
                 $('#care.tabcontent').html(`<span class="jtpl-pdp-tab-sku"><span class="gemstone_detail">${info}</span></span>`);
                  $('.tablinks[data-attr="care"]').show();
                  break;
                case 'Ruby':
                   var info = $('#info-section').attr('data-gudie-ruby');
                   $('#care.tabcontent').html(`<span class="jtpl-pdp-tab-sku"><span class="gemstone_detail">${info}</span></span>`);
                  $('.tablinks[data-attr="care"]').show();
                  break;
                   case 'Topaz':
                   var info = $('#info-section').attr('data-gudie-topaz');
                  $('#care.tabcontent').html(`<span class="jtpl-pdp-tab-sku"><span class="gemstone_detail">${info}</span></span>`);
                  $('.tablinks[data-attr="care"]').show();
                   break;
                   case 'Tanzanite':
                   var info = $('#info-section').attr('data-gudie-tanzanite');
                  $('#care.tabcontent').html(`<span class="jtpl-pdp-tab-sku"><span class="gemstone_detail">${info}</span></span>`);
                  $('.tablinks[data-attr="care"]').show();
              }
              
              }
              
 }
        
})
     
      
  
